<template>
  <div class="main">
    <my_menu2 page_name="身份证读取" back_type="close" back_icon="md-close"></my_menu2>

    <div class="content">
      <div class="content_tishi">
        <span>
          通过【蓝牙读卡器】刷过的身份证，信息会上传到系统中，更新身份证信息时可以快捷带入一键更新。
        </span>
        <div>
          <span class="weixinqr" @click="transfer_idcard" style="margin-right: 10px">
            仅更新身份证照片
          </span>
          <span class="weixinqr" @click="export_table" style="margin-right: 10px">
            导出当前页数据
          </span>
          <!-- <span class="weixinqr" @click="show_qr = true"> 点击查看二维码 </span> -->
        </div>
      </div>
      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>
        <Table
          size="small"
          ref="table"
          :height="windowHeight - 140"
          border
          :columns="columns"
          :data="table_data"
          @on-selection-change="table_selection_change"
        >
          <template #avatar="{ row }">
            <img
              :src="'data:image/png;base64,' + row.avatar"
              @click="click_img('data:image/png;base64,' + row.avatar)"
              class="avatar"
              alt=""
            />
          </template>
          <template #img_a="{ row }">
            <img
              v-if="row.img_a_url"
              :src="row.img_a_url"
              @click="click_img(row.img_a_url)"
              class="idcardimg"
              alt=""
            />
            <span v-else class="create_idcard_img" @click="create_idcard_img(row)"
              >点击生成照片</span
            >
          </template>
          <template #img_b="{ row }">
            <img
              v-if="row.img_b_url"
              :src="row.img_b_url"
              @click="click_img(row.img_b_url)"
              class="idcardimg"
              alt=""
            />
            <span v-else class="create_idcard_img" @click="create_idcard_img(row)"
              >点击生成照片</span
            >
          </template>
        </Table>
        <div class="content_page">
          <Page
            v-model="page"
            :page-size-opts="page_size_opts"
            @on-page-size-change="page_size_change"
            show-sizer
            show-total
            :total="total_count"
            :page-size="limit"
            @on-change="page_change"
          />
        </div>
      </div>
    </div>
    <Modal v-model="show_qr" title="查看二维码" :footer-hide="true" width="300">
      <div class="show_qr_div">
        <div>
          <img
            src="@/assets/image/idcard/xcxqr.png"
            style="width: 150px; height: 150px"
            alt=""
          />
        </div>
        <div>微信打一打，打开小程序</div>
      </div>
    </Modal>
  </div>
</template>

<script>
// import my_menu from '@/component/menu/menu.vue'
import { http } from "@/utils/http.js";
import { thisTypeAnnotation } from "@babel/types";
import my_menu2 from "@/component/menu/menu2.vue";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      page_size_opts: [20, 50, 100, 200],
      //系统列表
      table_data: [],
      columns: [],
      limit: 20,
      table_loading: false,
      page: 1,
      total_count: 0,
      add_field_show: false,
      show_qr: false,
      table_selection: [],
      project_id:""
    };
  },

  mounted() {
    this.window_change();
    var query = this.$route.query
    this.project_id = query.project_id
    this.get_user_list();
  },

  methods: {
    transfer_idcard() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请至少选择一个");
        return;
      }
      var idcard_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        idcard_list.push(this.table_selection[i]["id_card_no"]);
      }

      var that = this;
      var obj = {
        idcard_list: idcard_list,
      };
      this.$Message.info(
        "正在更新身份证正反面照片，请稍等一下,成功会有提示,请勿多次点击哟！"
      );

      http("post", process.env.VUE_APP_HOST + "/swiper_idcard/transfer_idcard", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    page_size_change(e) {
      this.limit = e;
      this.page = 1;
      this.get_user_list();
    },

    export_table() {
      this.$refs.table.exportCsv({
        filename: "识别身份证数据",
      });
    },
    click_img(url) {
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    //获取用户列表
    create_idcard_img(row) {
      var that = this;
      var obj = {
        swiper_id: row.swiper_id,
      };
      this.$Message.info("正在生成【" + row.name + "】身份证正反面照片，请稍等.");
      http(
        "post",
        process.env.VUE_APP_HOST + "/swiper_idcard/create_idcard_img",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    page_change(e) {
      this.get_user_list();
    },

    //获取用户列表
    get_user_list() {
      var that = this;
      var obj = {
        page: this.page,
        limit: this.limit,
        project_id:this.project_id
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/swiper_idcard/swiper_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.table_data;
            that.columns = res.data.columns;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    table_selection_change(e) {
      this.table_selection = e;
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.idcardimg {
  width: 85px;
  height: 50px;
  border: 1px solid #f1f1f1;
  cursor: pointer;
}

.avatar {
  cursor: pointer;
  width: 40px;
  height: 50px;
  border: 1px solid #f1f1f1;
}

.create_idcard_img {
  color: #0466dd;
  cursor: pointer;
}

.show_qr_div {
  text-align: center;
}

.weixinqr {
  font-size: 12px;
  color: #1074f0;
  cursor: pointer;
}

.content_tishi {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  background-color: #fadbd8;
  padding: 3px 10px;
  border-radius: 3px;
  margin-bottom: 10px;
  align-items: center;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  background-color: #fff;
  right: 0px;
  top: 0px;
  height: clac(100vh-150px);
  padding: 50px 10px 10px 10px;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
